import React, { Component } from "react";
import { Link } from "react-router-dom";
import Dropdown from "../component/Dropdown";
import TextField from "../component/TextField";
import FpgDeleteIcon from "../icons/fpgdeleteicon";
import FpgDisableIcon from "../icons/fpgdisableicon";
import FpgeeditIcon from "../icons/fpgediticon";
import FpgpublishIcon from "../icons/fpgpublishicon";
import FpgAdminOnlyicon from "../icons/fpgAdminOnlyicon";
import PlusIcon from "../icons/plusicon";
import ShowPassIcon from "../icons/ShowPassIcon";
import ViewIcon from "../icons/viewIcon";
import MainLayout from "../mainLayout";
import PopUpCustomAll from "../component/fpg/create/popUpCustomAll";
import Loader from "../component/loader";
import CalendarIcon from '../icons/calendaricon';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import DropdownMaster from '../component/DropdownMaster';
import ProductCompareBenefits from '../component/ProductCompareBenefits';
//Service import
import service from "../services";
//Validation import
import SimpleReactValidator from "simple-react-validator";

// Editors
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { convertFromRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

//Redux Connect
import { connect } from "react-redux";
import moment from "moment";
import TextEditor from "../component/TextEditor";
import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";
import { bindActionCreators } from "redux";
import { ActCreators } from "../redux/bindActionCretor";
import RecordPresenceBanner from "../component/RecordPresenceBanner";
import ConflictSaveModal from "../component/ConflictSaveModal";
let sub;

const mapStateToProps = (state) => ({
  ProductEditListEditId: state.ProductEditListEditId,
  recordViewers: state.recordViewers,
  recordConflict: state.recordConflict,
  getLoginAdminByID: state.getLoginAdminByID,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ActCreators, dispatch);
};
class ProductDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      getAlldataProductEditList: [],
      loaderFlag: false,
      deleteFilm: false,
      showConflictModal: false,
      publishFilm: false,
      disableFilm: false,
      hideFromLiveFilm: false,
      showFromLiveFilm: false,
      onSale: false,
      onSoldOut: "",
      name: "",
      onSale: false,
      onSoldOut: "",
      summary: EditorState.createEmpty(),
      desc: EditorState.createEmpty(),
      price: "",
      earlyPriceText: "",
      earlyPrice: 0,
      changeCategoryTitleName: false,
      getLastUpdated: "",
      discardPopup: false,
      earlyPriceStartDate:{date:new Date(),hour:{value:'12',label:'12'},min:{value:'12',label:'12'},state:{value:'AM',label:'AM'}},
      earlyPriceEndDate:{date:new Date(new Date().setDate(new Date().getDate() + 1)),hour:{value:'12',label:'12'},min:{value:'12',label:'12'},state:{value:'AM',label:'AM'}},
      earlyAccessStartDate:{date:new Date(),hour:{value:'12',label:'12'},min:{value:'12',label:'12'},state:{value:'AM',label:'AM'}},
      earlyAccessEndDate:{date:new Date(new Date().setDate(new Date().getDate() + 1)),hour:{value:'12',label:'12'},min:{value:'12',label:'12'},state:{value:'AM',label:'AM'}},
      publicSalesStartDate:{date:new Date(),hour:{value:'12',label:'12'},min:{value:'12',label:'12'},state:{value:'AM',label:'AM'}},
      publicSalesEndDate:{date:new Date(new Date().setDate(new Date().getDate() + 1)),hour:{value:'12',label:'12'},min:{value:'12',label:'12'},state:{value:'AM',label:'AM'}},
      myLibraryStartDate:{date:new Date(),hour:{value:'12',label:'12'},min:{value:'12',label:'12'},state:{value:'AM',label:'AM'}},
      myLibraryEndDate:{date:new Date(new Date().setDate(new Date().getDate() + 1)),hour:{value:'12',label:'12'},min:{value:'12',label:'12'},state:{value:'AM',label:'AM'}},
      waitListStartDate:{date:new Date(),hour:{value:'12',label:'12'},min:{value:'12',label:'12'},state:{value:'AM',label:'AM'}},
      waitListEndDate:{date:new Date(new Date().setDate(new Date().getDate() + 1)),hour:{value:'12',label:'12'},min:{value:'12',label:'12'},state:{value:'AM',label:'AM'}},
      myLibraryType:1,
      screeningType: [
        { _id: 1, name: 'None' },
        { _id: 2, name: 'My Viewing Room' },
        { _id: 3, name: 'P&I My Viewing Room' }
      ],
      waitlistTypeOption:[
        { _id: 'standard', name: 'Standard' },
        { _id: 'unlimited', name: 'Unlimited' },
        { _id: 'unlimitedp&i', name: 'Unlimited - P&I' }
      ],
      waitlistType:'standard',
      isByPass: false,
      isGiftable: false,
      validScreeningTypesOption:[],
      validScreeningTypes:[],
      validScreeningTypesList:[],
      label:'',
      labelError:false,
      status:1,
      productAdminStatus:false,
      location:'inperson',
      isproductdetailEdited: false,
      earlyAccess2StartDate:{date:new Date(),hour:{value:'12',label:'12'},min:{value:'12',label:'12'},state:{value:'AM',label:'AM'}},
      earlyAccess2EndDate:{date:new Date(new Date().setDate(new Date().getDate() + 1)),hour:{value:'12',label:'12'},min:{value:'12',label:'12'},state:{value:'AM',label:'AM'}},
      earlyAccess3StartDate:{date:new Date(),hour:{value:'12',label:'12'},min:{value:'12',label:'12'},state:{value:'AM',label:'AM'}},
      earlyAccess3EndDate:{date:new Date(new Date().setDate(new Date().getDate() + 1)),hour:{value:'12',label:'12'},min:{value:'12',label:'12'},state:{value:'AM',label:'AM'}},
      membershipTypes: [],
      membership2Types: [],
      membership3Types: [],
      membershipLevelsOptions: [],
      productClassification: '',
      productBenefits: [],
      showProductInCompareBenefits: false,
      sponsorName: '',
      eventSponsors: [],
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
    this._hasLeftPresence = false;
  }

  getCurrentFormData = () => {
    const normalizeDraftHtml = (editorState) => {
        if (!editorState || typeof editorState === 'string') return '';
        const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        return (html === '<p></p>\n' || html === '<p></p>') ? '' : html;
    };
    
    return cloneDeep({
      name: this.state.name,
      summary: normalizeDraftHtml(this.state.summary),
      desc: normalizeDraftHtml(this.state.desc),
      price: this.state.price,
      earlyPrice: this.state.earlyPrice,
      earlyPriceText: this.state.earlyPriceText,
      label: this.state.label,
      accessType: this.state.accessType,
      status: this.state.status,
      hideFromLive: this.state.hideFromLive,
      eventiveId: this.state.eventiveId,
      eventiveCode: this.state.eventiveCode,
      earlyPriceStartDate: this.state.earlyPriceStartDate,
      earlyPriceEndDate: this.state.earlyPriceEndDate,
      earlyAccessStartDate: this.state.earlyAccessStartDate,
      earlyAccessEndDate: this.state.earlyAccessEndDate,
      publicSalesStartDate: this.state.publicSalesStartDate,
      publicSalesEndDate: this.state.publicSalesEndDate,
      waitListStartDate: this.state.waitListStartDate,
      waitListEndDate: this.state.waitListEndDate,
      myLibraryType: this.state.myLibraryType,
      waitlistType: this.state.waitlistType,
      isByPass: this.state.isByPass,
      isGiftable: this.state.isGiftable,
      validScreeningTypes: this.state.validScreeningTypes !== null && this.state.validScreeningTypes !== undefined ? this.state.validScreeningTypes.map(item => item.value) : [],
      earlyAccess2StartDate: this.state.earlyAccess2StartDate,
      earlyAccess2EndDate: this.state.earlyAccess2EndDate,
      earlyAccess3StartDate: this.state.earlyAccess3StartDate,
      earlyAccess3EndDate: this.state.earlyAccess3EndDate,
      membershipTypes: this.state.membershipTypes,
      membership2Types: this.state.membership2Types,
      membership3Types: this.state.membership3Types,
      productClassification: this.state.productClassification,
      productBenefits: this.state.productBenefits,
      showProductInCompareBenefits: this.state.showProductInCompareBenefits,
      sponsorName: this.state.sponsorName,
    });
  };

  markproductdetailEdited = () => {
    if (this.state.initialData) {
      const isDirty = !isEqual(this.state.initialData, this.getCurrentFormData());
      if (this.state.isproductdetailEdited !== isDirty) {
        this.setState({ isproductdetailEdited: isDirty });
      }
    }
  }

  updateState = (state, callback) => {
    this.setState(state, () => {
      this.markproductdetailEdited();
      if (callback) callback();
    });
  }

  componentDidMount() {
    this.props.ClearRecordPresence();
    const recordId = this.props.ProductEditListEditId;
    if (recordId) {
      this.apiserve.sendevent("RecordPresence|join", {
        modelName: "stripeProduct",
        recordId: recordId
      });
      window.addEventListener('beforeunload', this._handleBeforeUnload);
    }
    if(this.props.ProductEditListEditId){
      this.getAllProductEditListdetails();
    } else {
      this.apiserve.sendevent("user|sff|getAllInitial", {host:process.env.REACT_APP_HOST});
    }
    this.getProductEditListdetails();
    this.setState({
      loaderFlag: true,
    });
  }

  _handleBeforeUnload = () => {
    if (this._hasLeftPresence) return;
    this._hasLeftPresence = true;

    const recordId = this.props.ProductEditListEditId;
    if (recordId) {
      this.apiserve.sendevent("RecordPresence|leave", {
        modelName: "stripeProduct",
        recordId: recordId
      });
    }
  }

  componentWillUnmount() {
    const recordId = this.props.ProductEditListEditId;

    window.removeEventListener('beforeunload', this._handleBeforeUnload);

    if (recordId && !this._hasLeftPresence) {
      this.apiserve.sendevent("RecordPresence|leave", {
        modelName: "stripeProduct",
        recordId: recordId
      });
    }

    sub.unsubscribe();
    this.props.ClearRecordPresence();
  }

  closeAdminUser = () => {
    this.setState({
      deleteFilm: false,
      publishFilm: false,
      disableFilm: false,
      discardPopup: false,
      hideFromLiveFilm: false,
      showFromLiveFilm: false,
      onSale: false,
      productAdminStatus:false
    });
  };

  onInputChange = (e) => {
    if(e.target.name === 'label'){
      if(e.target.value.trim().length <= 25){
        this.updateState({
          [e.target.name]: e.target.value.trimStart(),
          labelError:false
        }); 
      } else {
        this.setState({
          labelError:true
        })
      }
    } else {
      this.updateState({
        [e.target.name]: e.target.value,
      });
    }
  };
  getProductEditListdetails = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "ticketCms|products|getDetail":

          const descBlocksFromHtml = htmlToDraft(response.data.desc ? response.data.desc : "");
          const descContentState = ContentState.createFromBlockArray(descBlocksFromHtml.contentBlocks, descBlocksFromHtml.entityMap);
          const desc = EditorState.createWithContent(descContentState);
          this.setState({ desc });

          const summaryBlocksFromHtml = htmlToDraft(response.data.summary ? response.data.summary : "");
          const summaryContentState = ContentState.createFromBlockArray(summaryBlocksFromHtml.contentBlocks, summaryBlocksFromHtml.entityMap);
          const summary = EditorState.createWithContent(summaryContentState);
          this.setState({ summary });
          console.log(response.data.earlyAccessStartDate,"response.data.earlyAccessStartDate", this.state.earlyAccessStartDate);
        


          let hoursEPSD = moment(response.data.earlyPriceStartDate).tz("US/Mountain").format('h');
          let minutesEPSD = moment(response.data.earlyPriceStartDate).tz("US/Mountain").format('mm');
          let stateEPSD = moment(response.data.earlyPriceStartDate).tz("US/Mountain").format('A');

          let hoursEPED = moment(response.data.earlyPriceEndDate).tz("US/Mountain").format('h');
          let minutesEPED = moment(response.data.earlyPriceEndDate).tz("US/Mountain").format('mm');
          let stateEPED = moment(response.data.earlyPriceEndDate).tz("US/Mountain").format('A');

          let hoursESD = moment(response.data.earlyAccessStartDate).tz("US/Mountain").format('h');
          let minutesESD = moment(response.data.earlyAccessStartDate).tz("US/Mountain").format('mm');
          let stateESD = moment(response.data.earlyAccessStartDate).tz("US/Mountain").format('A');

          let hoursEED = moment(response.data.earlyAccessEndDate).tz("US/Mountain").format('h');
          let minutesEED = moment(response.data.earlyAccessEndDate).tz("US/Mountain").format('mm');
          let stateEED = moment(response.data.earlyAccessEndDate).tz("US/Mountain").format('A');

          let hoursPSD = moment(response.data.publicSalesStartDate).tz("US/Mountain").format('h');
          let minutesPSD = moment(response.data.publicSalesStartDate).tz("US/Mountain").format('mm');
          let statePSD = moment(response.data.publicSalesStartDate).tz("US/Mountain").format('A');

          let hoursPED = moment(response.data.publicSalesEndDate).tz("US/Mountain").format('h');
          let minutesPED = moment(response.data.publicSalesEndDate).tz("US/Mountain").format('mm');
          let statePED = moment(response.data.publicSalesEndDate).tz("US/Mountain").format('A');

          let hoursWSD = moment(response.data.waitListStartDate).tz("US/Mountain").format('h');
          let minutesWSD = moment(response.data.waitListStartDate).tz("US/Mountain").format('mm');
          let stateWSD = moment(response.data.waitListStartDate).tz("US/Mountain").format('A');

          let hoursWED = moment(response.data.waitListEndDate).tz("US/Mountain").format('h');
          let minutesWED = moment(response.data.waitListEndDate).tz("US/Mountain").format('mm');
          let stateWED = moment(response.data.waitListEndDate).tz("US/Mountain").format('A');


          let yearsEPSD = moment(response.data.earlyPriceStartDate).tz("US/Mountain").format('YYYY')
          let monthsEPSD = moment(response.data.earlyPriceStartDate).tz("US/Mountain").format('MM') - 1
          let datesEPSD = moment(response.data.earlyPriceStartDate).tz("US/Mountain").format('DD')
          let EPSdate = new Date(yearsEPSD,monthsEPSD,datesEPSD)
          EPSdate.setHours(hoursEPSD)
          EPSdate.setMinutes(minutesEPSD)

          let yearsEPED = moment(response.data.earlyPriceEndDate).tz("US/Mountain").format('YYYY')
          let monthsEPED = moment(response.data.earlyPriceEndDate).tz("US/Mountain").format('MM') - 1
          let datesEPED = moment(response.data.earlyPriceEndDate).tz("US/Mountain").format('DD')
          let EPEdate = new Date(yearsEPED,monthsEPED,datesEPED)
          EPEdate.setHours(hoursEPSD)
          EPEdate.setMinutes(minutesEPSD)

          let yearsESD = moment(response.data.earlyAccessStartDate).tz("US/Mountain").format('YYYY')
          let monthsESD = moment(response.data.earlyAccessStartDate).tz("US/Mountain").format('MM') - 1
          let datesESD = moment(response.data.earlyAccessStartDate).tz("US/Mountain").format('DD')
          let ESdate = new Date(yearsESD,monthsESD,datesESD)
          ESdate.setHours(hoursESD)
          ESdate.setMinutes(minutesESD)

          let yearsEED = moment(response.data.earlyAccessEndDate).tz("US/Mountain").format('YYYY')
          let monthsEED = moment(response.data.earlyAccessEndDate).tz("US/Mountain").format('MM') - 1
          let datesEED = moment(response.data.earlyAccessEndDate).tz("US/Mountain").format('DD')
          let EEdate = new Date(yearsEED,monthsEED,datesEED)
          EEdate.setHours(hoursESD)
          EEdate.setMinutes(minutesESD)

          let yearsPSD = moment(response.data.publicSalesStartDate).tz("US/Mountain").format('YYYY')
          let monthsPSD = moment(response.data.publicSalesStartDate).tz("US/Mountain").format('MM') - 1
          let datesPSD = moment(response.data.publicSalesStartDate).tz("US/Mountain").format('DD')
          let PSdate = new Date(yearsPSD,monthsPSD,datesPSD)
          PSdate.setHours(hoursESD)
          PSdate.setMinutes(minutesESD)

          let yearsPED = moment(response.data.publicSalesEndDate).tz("US/Mountain").format('YYYY')
          let monthsPED = moment(response.data.publicSalesEndDate).tz("US/Mountain").format('MM') - 1
          let datesPED = moment(response.data.publicSalesEndDate).tz("US/Mountain").format('DD')
          let PEdate = new Date(yearsPED,monthsPED,datesPED)
          PEdate.setHours(hoursESD)
          PEdate.setMinutes(minutesESD)

          let yearsWSD = moment(response.data.waitListStartDate).tz("US/Mountain").format('YYYY')
          let monthsWSD = moment(response.data.waitListStartDate).tz("US/Mountain").format('MM') - 1
          let datesWSD = moment(response.data.waitListStartDate).tz("US/Mountain").format('DD')
          let WSdate = new Date(yearsWSD,monthsWSD,datesWSD)
          WSdate.setHours(hoursWSD)
          WSdate.setMinutes(minutesWSD)
          
          let yearsWED = moment(response.data.waitListEndDate).tz("US/Mountain").format('YYYY')
          let monthsWED = moment(response.data.waitListEndDate).tz("US/Mountain").format('MM') - 1
          let datesWED = moment(response.data.waitListEndDate).tz("US/Mountain").format('DD')
          let WEdate = new Date(yearsWED,monthsWED,datesWED)
          
          WEdate.setHours(hoursWED)
          WEdate.setMinutes(minutesWED)

          let hoursEA2SD = response.data.earlyAccess2StartDate ? moment(response.data.earlyAccess2StartDate).tz("US/Mountain").format('h') : '12';
          let minutesEA2SD = response.data.earlyAccess2StartDate ? moment(response.data.earlyAccess2StartDate).tz("US/Mountain").format('mm') : '12';
          let stateEA2SD = response.data.earlyAccess2StartDate ? moment(response.data.earlyAccess2StartDate).tz("US/Mountain").format('A') : 'AM';

          let hoursEA2ED = response.data.earlyAccess2EndDate ? moment(response.data.earlyAccess2EndDate).tz("US/Mountain").format('h') : '12';
          let minutesEA2ED = response.data.earlyAccess2EndDate ? moment(response.data.earlyAccess2EndDate).tz("US/Mountain").format('mm') : '12';
          let stateEA2ED = response.data.earlyAccess2EndDate ? moment(response.data.earlyAccess2EndDate).tz("US/Mountain").format('A') : 'AM';

          let EA2Sdate = new Date();
          let EA2Edate = new Date(new Date().setDate(new Date().getDate() + 1));
          if (response.data.earlyAccess2StartDate) {
            let yearsEA2SD = moment(response.data.earlyAccess2StartDate).tz("US/Mountain").format('YYYY');
            let monthsEA2SD = moment(response.data.earlyAccess2StartDate).tz("US/Mountain").format('MM') - 1;
            let datesEA2SD = moment(response.data.earlyAccess2StartDate).tz("US/Mountain").format('DD');
            EA2Sdate = new Date(yearsEA2SD, monthsEA2SD, datesEA2SD);
            EA2Sdate.setHours(hoursEA2SD);
            EA2Sdate.setMinutes(minutesEA2SD);
          }
          if (response.data.earlyAccess2EndDate) {
            let yearsEA2ED = moment(response.data.earlyAccess2EndDate).tz("US/Mountain").format('YYYY');
            let monthsEA2ED = moment(response.data.earlyAccess2EndDate).tz("US/Mountain").format('MM') - 1;
            let datesEA2ED = moment(response.data.earlyAccess2EndDate).tz("US/Mountain").format('DD');
            EA2Edate = new Date(yearsEA2ED, monthsEA2ED, datesEA2ED);
            EA2Edate.setHours(hoursEA2ED);
            EA2Edate.setMinutes(minutesEA2ED);
          }

          let hoursEA3SD = response.data.earlyAccess3StartDate ? moment(response.data.earlyAccess3StartDate).tz("US/Mountain").format('h') : '12';
          let minutesEA3SD = response.data.earlyAccess3StartDate ? moment(response.data.earlyAccess3StartDate).tz("US/Mountain").format('mm') : '12';
          let stateEA3SD = response.data.earlyAccess3StartDate ? moment(response.data.earlyAccess3StartDate).tz("US/Mountain").format('A') : 'AM';

          let hoursEA3ED = response.data.earlyAccess3EndDate ? moment(response.data.earlyAccess3EndDate).tz("US/Mountain").format('h') : '12';
          let minutesEA3ED = response.data.earlyAccess3EndDate ? moment(response.data.earlyAccess3EndDate).tz("US/Mountain").format('mm') : '12';
          let stateEA3ED = response.data.earlyAccess3EndDate ? moment(response.data.earlyAccess3EndDate).tz("US/Mountain").format('A') : 'AM';

          let EA3Sdate = new Date();
          let EA3Edate = new Date(new Date().setDate(new Date().getDate() + 1));
          if (response.data.earlyAccess3StartDate) {
            let yearsEA3SD = moment(response.data.earlyAccess3StartDate).tz("US/Mountain").format('YYYY');
            let monthsEA3SD = moment(response.data.earlyAccess3StartDate).tz("US/Mountain").format('MM') - 1;
            let datesEA3SD = moment(response.data.earlyAccess3StartDate).tz("US/Mountain").format('DD');
            EA3Sdate = new Date(yearsEA3SD, monthsEA3SD, datesEA3SD);
            EA3Sdate.setHours(hoursEA3SD);
            EA3Sdate.setMinutes(minutesEA3SD);
          }
          if (response.data.earlyAccess3EndDate) {
            let yearsEA3ED = moment(response.data.earlyAccess3EndDate).tz("US/Mountain").format('YYYY');
            let monthsEA3ED = moment(response.data.earlyAccess3EndDate).tz("US/Mountain").format('MM') - 1;
            let datesEA3ED = moment(response.data.earlyAccess3EndDate).tz("US/Mountain").format('DD');
            EA3Edate = new Date(yearsEA3ED, monthsEA3ED, datesEA3ED);
            EA3Edate.setHours(hoursEA3ED);
            EA3Edate.setMinutes(minutesEA3ED);
          }

          this.setState(
            {
              getAlldataProductEditList: response.data,
              name: response.data.name,
              // summary: response.data.summary,
              price: response.data.price,
              earlyPrice: response.data.earlyPrice,
              earlyPriceText: response.data.earlyPriceText,
              // desc: response.data.desc,
              label:response.data.label,
              accessType: response.data.accessType,
              group: response.data.group,
              status: response.data.status,
              hideFromLive: response.data.hideFromLive,
              onSoldOut: response.data.globalSoldOut,
              eventiveId: response.data.eventiveId,
              eventiveCode: response.data.eventiveCode,
              earlyAccessStartDate:response.data.earlyAccessStartDate ? {date:new Date(ESdate),hour:{ value: hoursESD, label: hoursESD },min:{ value: minutesESD, label: minutesESD },state:{ value: stateESD, label: stateESD }} : this.state.earlyAccessStartDate,
              earlyAccessEndDate:response.data.earlyAccessEndDate ? {date:new Date(EEdate),hour:{ value: hoursEED, label: hoursEED },min:{ value: minutesEED, label: minutesEED },state:{ value: stateEED, label: stateEED }} : this.state.earlyAccessEndDate,
              earlyPriceStartDate:response.data.earlyPriceStartDate ? {date:new Date(EPSdate),hour:{ value: hoursEPSD, label: hoursEPSD },min:{ value: minutesEPSD, label: minutesEPSD },state:{ value: stateEPSD, label: stateEPSD }} : this.state.earlyPriceStartDate,
              earlyPriceEndDate:response.data.earlyPriceEndDate ? {date:new Date(EPEdate),hour:{ value: hoursEPED, label: hoursEPED },min:{ value: minutesEPED, label: minutesEPED },state:{ value: stateEPED, label: stateEPED }} : this.state.earlyPriceEndDate,
              publicSalesStartDate:response.data.publicSalesStartDate ? {date:new Date(PSdate),hour:{ value: hoursPSD, label: hoursPSD },min:{ value: minutesPSD, label: minutesPSD },state:{ value: statePSD, label: statePSD }} : this.state.publicSalesStartDate,
              publicSalesEndDate:response.data.publicSalesEndDate ? {date:new Date(PEdate),hour:{ value: hoursPED, label: hoursPED },min:{ value: minutesPED, label: minutesPED },state:{ value: statePED, label: statePED }} : this.state.publicSalesEndDate,
              myLibraryType:response.data.myLibraryType || 1,
              waitListStartDate:response.data.waitListStartDate ? {date:new Date(WSdate),hour:{ value: hoursWSD, label: hoursWSD },min:{ value: minutesWSD, label: minutesWSD },state:{ value: stateWSD, label: stateWSD }} : this.state.waitListStartDate,
              waitListEndDate:response.data.waitListEndDate ? {date:new Date(WEdate),hour:{ value: hoursWED, label: hoursWED },min:{ value: minutesWED, label: minutesWED },state:{ value: stateWED, label: stateWED }} : this.state.waitListEndDate,
              userGroup:response.data.userGroup,
              adminStatus:response.data.adminStatus,
              waitlistType:response?.data?.waitlistType,
              isByPass:response?.data?.isByPass,
              isGiftable:response?.data?.isGiftable,
              validScreeningTypesList:response?.data?.validScreeningTypes,
              location:response?.data?.type,
              isproductdetailEdited: false,
              earlyAccess2StartDate: response.data.earlyAccess2StartDate ? {date:new Date(EA2Sdate),hour:{ value: hoursEA2SD, label: hoursEA2SD },min:{ value: minutesEA2SD, label: minutesEA2SD },state:{ value: stateEA2SD, label: stateEA2SD }} : this.state.earlyAccess2StartDate,
              earlyAccess2EndDate: response.data.earlyAccess2EndDate ? {date:new Date(EA2Edate),hour:{ value: hoursEA2ED, label: hoursEA2ED },min:{ value: minutesEA2ED, label: minutesEA2ED },state:{ value: stateEA2ED, label: stateEA2ED }} : this.state.earlyAccess2EndDate,
              earlyAccess3StartDate: response.data.earlyAccess3StartDate ? {date:new Date(EA3Sdate),hour:{ value: hoursEA3SD, label: hoursEA3SD },min:{ value: minutesEA3SD, label: minutesEA3SD },state:{ value: stateEA3SD, label: stateEA3SD }} : this.state.earlyAccess3StartDate,
              earlyAccess3EndDate: response.data.earlyAccess3EndDate ? {date:new Date(EA3Edate),hour:{ value: hoursEA3ED, label: hoursEA3ED },min:{ value: minutesEA3ED, label: minutesEA3ED },state:{ value: stateEA3ED, label: stateEA3ED }} : this.state.earlyAccess3EndDate,
              membershipTypes: (response.data.membershipTypes || []).map(m => ({ value: m, label: m })),
              membership2Types: (response.data.membership2Types || []).map(m => ({ value: m, label: m })),
              membership3Types: (response.data.membership3Types || []).map(m => ({ value: m, label: m })),
              productClassification: response.data.productClassification || '',
              productBenefits: response.data.productBenefits || [],
              showProductInCompareBenefits: response.data.showProductInCompareBenefits !== false,
              sponsorName: response.data.sponsorName || '',
              getLastUpdated: {
                updatedAt: response?.data?.updatedAt,
                updatedBy: {
                  fname: response?.data?.updatedBy?.fname,
                  lname: response?.data?.updatedBy?.lname
                }
              },
              isproductdetailEdited: false,
            });
          this.apiserve.sendevent("user|sff|getAllInitial", {host:process.env.REACT_APP_HOST});
          break;
        case "ticketCms|products|update":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
            this.setState({
              isproductdetailEdited: false,
            }, () => this.apiserve.success("Products updated successful."))
            this.getAllProductEditListdetails();
          }

          break;
        case "ticketCms|products|create":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
            this.setState({
              loaderFlag: false,
              isproductdetailEdited: false,
            }, () => this.apiserve.success("Products Added successful.")) || this.props.history.push({ pathname: "/product-list" })
          }

          break;
        case "ticketCms|products|remove":
          this.props.history.push("/product-list");
          break;
        case "ticketCms|products|updateStatus":
          const { status, hideFromLive } = response.data;
          this.setState(q => ({ ...q, status, hideFromLive }));
          this.closeAdminUser();
          break;
        case "ticketCms|products|globalSoldOut":
          if (response.error === false) {
            this.setState({ onSale: false, onSoldOut: response.data.globalSoldOut })
          }
          break;
        case "ticketCms|products|updateAdminStatus":
          if (response.error === false) {
            this.setState({ productAdminStatus: false, adminStatus: response.data.adminStatus })
          }
          break;
        case "user|sff|getAllInitial":
          if (response.error === false) {
            const membershipLevelsOptions = Object.entries(response?.data?.membership?.levels || {}).map(([key, value]) => ({ value: key, label: value })).sort((a, b) => a.label.localeCompare(b.label));
            this.setState({ validScreeningTypesOption: response?.data?.film?.screnningTypeList, membershipLevelsOptions, eventSponsors: response?.data?.eventSponsors || [] },() => {this.setState({ loaderFlag: false, });})
            if(this.props.ProductEditListEditId){
              var options = []
                response.data.film.screnningTypeList.filter(_ => this.state.location === 'inperson' ? _.locationType === '1' : _.locationType === '2').map(item => {
                  if(this.state.validScreeningTypesList.includes(item.type)){
                    options.push({ value: item.type, label: item.displayName})
                  }
                })
              this.setState({validScreeningTypes:options}, () => {
                this.setState({ loaderFlag: false, initialData: this.getCurrentFormData(), isproductdetailEdited: false });
              })
            } else {
              this.setState({ loaderFlag: false, initialData: this.getCurrentFormData(), isproductdetailEdited: false });
            }
          }
          break;

        case "RecordPresence|viewersUpdate":
          if (response?.data?.recordId === this.props.ProductEditListEditId) {
            const currentUserId = this.props.getLoginAdminByID;
            const viewers = response?.data?.viewers || [];
            const currentUserSessionCount = viewers.filter(v => v?.userId === currentUserId).length;
            const currentUserHasMultipleSessions = currentUserSessionCount > 1;
            const seenIds = new Set();
            const filteredViewers = viewers
              .filter(v => {
                if (v?.userId === currentUserId) {
                  return currentUserHasMultipleSessions;
                }
                return true;
              })
              .filter(v => {
                if (seenIds.has(v?.userId)) return false;
                seenIds.add(v?.userId);
                return true;
              })
              .map(v => ({
                userId: v?.userId,
                userName: `${v?.fname || ''} ${v?.lname || ''}`.trim() || 'Unknown User'
              }));
            this.props.SetRecordViewers(filteredViewers);
          }
          break;

        case "RecordPresence|recordUpdated":
          if (response?.data?.recordId === this.props.ProductEditListEditId && response?.data?.updatedBy?._id !== this.props.getLoginAdminByID) {
            const updatedBy = response?.data?.updatedBy;
            this.props.SetRecordConflict({
              userName: updatedBy
                ? `${updatedBy?.fname || ''} ${updatedBy?.lname || ''}`.trim()
                : 'another user',
              updatedAt: response?.data?.updatedAt
            });
          }
          break;
      }
    });
  };

  getAllProductEditListdetails = () => {
    var productId = this.props.ProductEditListEditId;
    this.apiserve.sendevent("ticketCms|products|getDetail", { productId });
  };

  soldOutYes = () => {
    this.apiserve.sendevent("ticketCms|products|globalSoldOut", {
      productId: this.props.ProductEditListEditId,
      "globalSoldOut": !this.state.onSoldOut
    });
  };
  adminStatusYes = () => {
    this.apiserve.sendevent("ticketCms|products|updateAdminStatus", {
      productId: this.props.ProductEditListEditId,
      "adminStatus": this.state.adminStatus === 1 ? 2 : 1
    });
    if(this.state.status === 2){
      this.apiserve.sendevent("ticketCms|products|updateStatus", {
        productId: this.props.ProductEditListEditId,
        hideFromLive:this.state.hideFromLive,
        status: 1,
      });
    }
  };
  deleteFilm = () => {
    this.setState({
      deleteFilm: true,
    });
  };

  soldOutFilm = () => {
    this.setState({
      onSale: !this.state.onSale,
    });
  };
  adminStatusUpdate = (e, status) => {
    this.setState({
      productAdminStatus: true,
    });
  };

  soldOutYes = () => {
    this.apiserve.sendevent("ticketCms|products|globalSoldOut", {
      productId: this.props.ProductEditListEditId,
      "globalSoldOut": !this.state.onSoldOut
    });
  };
  deleteFilmPopupYes = () => {
    this.apiserve.sendevent("ticketCms|products|remove", {
      productId: this.props.ProductEditListEditId,
    });
  };

  publishFilm = () => {
    this.setState({
      publishFilm: true,
    });
  };

  publishFilmPopupYes = () => {
    this.apiserve.sendevent("ticketCms|products|updateStatus", {
      productId: this.props.ProductEditListEditId,
      hideFromLive:this.state.hideFromLive,
      status: 1,
    });
  };

  disableFilm = () => {
    this.setState({
      disableFilm: true,
    });
  };
  soldOutFilm = () => {
    this.setState({
      onSale: !this.state.onSale,
    });
  };


  disableFilmPopupYes = () => {
    this.apiserve.sendevent("ticketCms|products|updateStatus", {
      productId: this.props.ProductEditListEditId,
      hideFromLive:this.state.hideFromLive,
      status: 2,
    });
  };

  discardPopupYes = () => {
    this.props.history.push({
      pathname: "/product-list"
    })
  }

  hideFromLiveFilm = () => {
    this.setState({
      hideFromLiveFilm: true
    })
  }

  hideFromLiveFilmPopupYes = () => {
    this.apiserve.sendevent("ticketCms|products|updateStatus", {
      productId: this.props.ProductEditListEditId,
      status:this.state.status,
      hideFromLive: true
    });
  }

  showFromLiveFilm = () => {
    this.setState({
      showFromLiveFilm: true
    })
  }

  showFromLiveFilmPopupYes = () => {
    this.apiserve.sendevent("ticketCms|products|updateStatus", {
      productId: this.props.ProductEditListEditId,
      status:this.state.status,
      hideFromLive: false
    });
  }

  getMtTime = (date) => {
    //Get offset from mountain time using UTC
    //change 360 t0 420
    let ABBR = moment.tz("America/Denver").format("z");
    let offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);
    // add that offset in date
    return moment(date).add(offDifference, 'minutes').toISOString()
  }

  submitFn = async (e) => {
    e.preventDefault();
    if (this.props.recordConflict) {
      this.setState({ showConflictModal: true });
      return;
    }
    if (this.validator.allValid()) {
    this.setState({ loaderFlag: true });
    // if (this.state.changeCategoryTitleName) {
    const name = convertToRaw(this.state.summary.getCurrentContent());
    const summary = draftToHtml(name);
    const make = convertToRaw(this.state.desc.getCurrentContent());
    const desc = draftToHtml(make);
    let dateEPSD = this.state.earlyPriceStartDate
    let dateEPED = this.state.earlyPriceEndDate
    let dateESD = this.state.earlyAccessStartDate
    let dateEED = this.state.earlyAccessEndDate
    let datePSD = this.state.publicSalesStartDate
    let datePED = this.state.publicSalesEndDate
    let dateWSD = this.state.waitListStartDate
    let dateWED = this.state.waitListEndDate
    let dateEA2SD = this.state.earlyAccess2StartDate
    let dateEA2ED = this.state.earlyAccess2EndDate
    let dateEA3SD = this.state.earlyAccess3StartDate
    let dateEA3ED = this.state.earlyAccess3EndDate
    dateEPSD.date.setHours(dateEPSD.state.value === 'PM' || dateEPSD.state.value === 'pm' ? parseInt(dateEPSD.hour.value) === 12 ? parseInt(dateEPSD.hour.value) : parseInt(dateEPSD.hour.value) + 12 : parseInt(dateEPSD.hour.value) === 12 ? parseInt(dateEPSD.hour.value) - 12 : parseInt(dateEPSD.hour.value), dateEPSD.min.value);
    dateEPED.date.setHours(dateEPED.state.value === 'PM' || dateEPED.state.value === 'pm' ? parseInt(dateEPED.hour.value) === 12 ? parseInt(dateEPED.hour.value) : parseInt(dateEPED.hour.value) + 12 : parseInt(dateEPED.hour.value) === 12 ? parseInt(dateEPED.hour.value) - 12 : parseInt(dateEPED.hour.value), dateEPED.min.value);
    dateESD.date.setHours(dateESD.state.value === 'PM' || dateESD.state.value === 'pm' ? parseInt(dateESD.hour.value) === 12 ? parseInt(dateESD.hour.value) : parseInt(dateESD.hour.value) + 12 : parseInt(dateESD.hour.value) === 12 ? parseInt(dateESD.hour.value) - 12 : parseInt(dateESD.hour.value), dateESD.min.value);
    dateEED.date.setHours(dateEED.state.value === 'PM' || dateEED.state.value === 'pm' ? parseInt(dateEED.hour.value) === 12 ? parseInt(dateEED.hour.value) : parseInt(dateEED.hour.value) + 12 : parseInt(dateEED.hour.value) === 12 ? parseInt(dateEED.hour.value) - 12 : parseInt(dateEED.hour.value), dateEED.min.value);
    datePSD.date.setHours(datePSD.state.value === 'PM' || datePSD.state.value === 'pm' ? parseInt(datePSD.hour.value) === 12 ? parseInt(datePSD.hour.value) : parseInt(datePSD.hour.value) + 12 : parseInt(datePSD.hour.value) === 12 ? parseInt(datePSD.hour.value) - 12 : parseInt(datePSD.hour.value), datePSD.min.value);
    datePED.date.setHours(datePED.state.value === 'PM' || datePED.state.value === 'pm' ? parseInt(datePED.hour.value) === 12 ? parseInt(datePED.hour.value) : parseInt(datePED.hour.value) + 12 : parseInt(datePED.hour.value) === 12 ? parseInt(datePED.hour.value) - 12 : parseInt(datePED.hour.value), datePED.min.value);
    dateWSD.date.setHours(dateWSD.state.value === 'PM' || dateWSD.state.value === 'pm' ? parseInt(dateWSD.hour.value) === 12 ? parseInt(dateWSD.hour.value) : parseInt(dateWSD.hour.value) + 12 : parseInt(dateWSD.hour.value) === 12 ? parseInt(dateWSD.hour.value) - 12 : parseInt(dateWSD.hour.value), dateWSD.min.value);
    dateWED.date.setHours(dateWED.state.value === 'PM' || dateWED.state.value === 'pm' ? parseInt(dateWED.hour.value) === 12 ? parseInt(dateWED.hour.value) : parseInt(dateWED.hour.value) + 12 : parseInt(dateWED.hour.value) === 12 ? parseInt(dateWED.hour.value) - 12 : parseInt(dateWED.hour.value), dateWED.min.value);
    dateEA2SD.date.setHours(dateEA2SD.state.value === 'PM' || dateEA2SD.state.value === 'pm' ? parseInt(dateEA2SD.hour.value) === 12 ? parseInt(dateEA2SD.hour.value) : parseInt(dateEA2SD.hour.value) + 12 : parseInt(dateEA2SD.hour.value) === 12 ? parseInt(dateEA2SD.hour.value) - 12 : parseInt(dateEA2SD.hour.value), dateEA2SD.min.value);
    dateEA2ED.date.setHours(dateEA2ED.state.value === 'PM' || dateEA2ED.state.value === 'pm' ? parseInt(dateEA2ED.hour.value) === 12 ? parseInt(dateEA2ED.hour.value) : parseInt(dateEA2ED.hour.value) + 12 : parseInt(dateEA2ED.hour.value) === 12 ? parseInt(dateEA2ED.hour.value) - 12 : parseInt(dateEA2ED.hour.value), dateEA2ED.min.value);
    dateEA3SD.date.setHours(dateEA3SD.state.value === 'PM' || dateEA3SD.state.value === 'pm' ? parseInt(dateEA3SD.hour.value) === 12 ? parseInt(dateEA3SD.hour.value) : parseInt(dateEA3SD.hour.value) + 12 : parseInt(dateEA3SD.hour.value) === 12 ? parseInt(dateEA3SD.hour.value) - 12 : parseInt(dateEA3SD.hour.value), dateEA3SD.min.value);
    dateEA3ED.date.setHours(dateEA3ED.state.value === 'PM' || dateEA3ED.state.value === 'pm' ? parseInt(dateEA3ED.hour.value) === 12 ? parseInt(dateEA3ED.hour.value) : parseInt(dateEA3ED.hour.value) + 12 : parseInt(dateEA3ED.hour.value) === 12 ? parseInt(dateEA3ED.hour.value) - 12 : parseInt(dateEA3ED.hour.value), dateEA3ED.min.value);
    let updateproducts = {
      name: this.state.name,
      summary: summary,
      desc: desc,
      price: this.state.price,
      earlyPrice: this.state.earlyPrice,
      earlyPriceText: this.state.earlyPriceText,
      label:this.state.label,
      accessType: this.state.accessType,
      productId: this.props.ProductEditListEditId,
      status: this.state.status,
      hideFromLive: this.state.hideFromLive,
      eventiveId: this.state.eventiveId,
      eventiveCode: this.state.eventiveCode,
      earlyPriceStartDate:this.getMtTime(dateEPSD.date),
      earlyPriceEndDate:this.getMtTime(dateEPED.date),
      earlyAccessStartDate:this.getMtTime(dateESD.date),
      earlyAccessEndDate:this.getMtTime(dateEED.date),
      publicSalesStartDate:this.getMtTime(datePSD.date),
      publicSalesEndDate:this.getMtTime(datePED.date),
      waitListStartDate:this.getMtTime(dateWSD.date),
      waitListEndDate:this.getMtTime(dateWED.date),
      myLibraryType:this.state.myLibraryType,
      waitlistType:this.state.waitlistType,
      isByPass:this.state.isByPass,
      isGiftable:this.state.isGiftable,
      validScreeningTypes:this.state.validScreeningTypes !== null ? this.state.validScreeningTypes.map(item => item.value) : [],
      earlyAccess2StartDate:this.getMtTime(dateEA2SD.date),
      earlyAccess2EndDate:this.getMtTime(dateEA2ED.date),
      earlyAccess3StartDate:this.getMtTime(dateEA3SD.date),
      earlyAccess3EndDate:this.getMtTime(dateEA3ED.date),
      membershipTypes: this.state.membershipTypes.map(item => item.value),
      membership2Types: this.state.membership2Types.map(item => item.value),
      membership3Types: this.state.membership3Types.map(item => item.value),
      productClassification: this.state.productClassification,
      productBenefits: this.state.group === 'newTicketing' ? this.state.productBenefits : [],
      showProductInCompareBenefits: this.state.group === 'newTicketing' ? this.state.showProductInCompareBenefits : false,
      sponsorName: this.state.sponsorName,
    };
    if(this.props.ProductEditListEditId){
      this.apiserve.sendevent("ticketCms|products|update", updateproducts);
    } else {
      updateproducts.group = this.state.group
      updateproducts.userGroup = this.state.group === 'presale' ? this.state.userGroup : this.state.group === "newTicketing" ? 'general' : 'boxoffice'
      updateproducts.location = this.state.location
      delete updateproducts['accessType']
      delete updateproducts['productId']
      this.apiserve.sendevent("ticketCms|products|create", updateproducts);
    }
    } else {
      this.validator.showMessages()
    }
    // }
  };

  validateModel = () => {
    this.setState({
      errorMsg: false,
    });
  };

  cancel = () => {
    this.setState({
      discardPopup: true
    })
  }
  onEditorStateChange = summary => {
    this.updateState({
      summary
    });
  };
  onEditorState = desc => {
    this.updateState({
      desc
    });
  };
  handleChangeDate = (date, type) => {
    // this.state.dateTime.forEach(event => {
    //     if (event._id === id) {
    //         event.date = date
    //     }
    // });
    console.log(type,"type");
    if(type === 'EarlyPriceStart'){
      this.updateState({
        earlyPriceStartDate:{...this.state.earlyPriceStartDate,date:date}
      })
    } else if(type === 'EarlyPriceEnd'){
      this.updateState({
        earlyPriceEndDate: { ...this.state.earlyPriceEndDate,date:date}
      })
    } else if(type === 'EarlyAccessStart'){
      this.updateState({
        earlyAccessStartDate:{...this.state.earlyAccessStartDate,date:date}
      })
    } else if(type === 'EarlyAccessEnd'){
      this.updateState({
        earlyAccessEndDate: { ...this.state.earlyAccessEndDate,date:date}
      })
    } else if (type === 'PublicSaleStart'){
      this.updateState({
        publicSalesStartDate:{...this.state.publicSalesStartDate,date:date}
      })
    } else if (type === 'PublicSaleEnd') {
      this.updateState({
        publicSalesEndDate:{...this.state.publicSalesEndDate,date:date}
      })
    } else if (type === 'EarlyAccess2Start'){
      this.updateState({
        earlyAccess2StartDate:{...this.state.earlyAccess2StartDate,date:date}
      })
    } else if (type === 'EarlyAccess2End'){
      this.updateState({
        earlyAccess2EndDate:{...this.state.earlyAccess2EndDate,date:date}
      })
    } else if (type === 'EarlyAccess3Start'){
      this.updateState({
        earlyAccess3StartDate:{...this.state.earlyAccess3StartDate,date:date}
      })
    } else if (type === 'EarlyAccess3End'){
      this.updateState({
        earlyAccess3EndDate:{...this.state.earlyAccess3EndDate,date:date}
      })
    } else if (type === 'WaitlistStart'){
      this.updateState({
        waitListStartDate:{...this.state.waitListStartDate,date:date}
      })
    } else {
      this.updateState({
        waitListEndDate:{...this.state.waitListEndDate,date:date}
      })
    }
    // this.setState({})
}

handleTimeHours = (e, type) => {
    // this.state.dateTime.forEach(event => {
    //     if (event._id === id) {
    //         event.hours = e
    //         // var m = moment(event.date);
    //         event.date = new Date(event.date.setHours(e.value))
    //         // m.set({h: e})
    //     }
    // });
    if(type === 'EarlyPriceStart'){
      this.updateState({
        earlyPriceStartDate:{...this.state.earlyPriceStartDate,hour:e,date:new Date(this.state.earlyPriceStartDate.date.setHours(e.value))}
      })
    } else if(type === 'EarlyPriceEnd'){
      this.updateState({
        earlyPriceEndDate: { ...this.state.earlyPriceEndDate,hour:e,date:new Date(this.state.earlyPriceEndDate.date.setHours(e.value))}
      })
    } else if(type === 'EarlyAccessStart'){
      this.updateState({
        earlyAccessStartDate:{...this.state.earlyAccessStartDate,hour:e,date:new Date(this.state.earlyAccessStartDate.date.setHours(e.value))}
      })
    } else if(type === 'EarlyAccessEnd'){
      this.updateState({
        earlyAccessEndDate: { ...this.state.earlyAccessEndDate,hour:e,date:new Date(this.state.earlyAccessEndDate.date.setHours(e.value))}
      })
    } else if (type === 'PublicSaleStart'){
      this.updateState({
        publicSalesStartDate:{...this.state.publicSalesStartDate,hour:e,date:new Date(this.state.publicSalesStartDate.date.setHours(e.value))}
      })
    } else if (type === 'PublicSaleEnd') {
      this.updateState({
        publicSalesEndDate:{...this.state.publicSalesEndDate,hour:e,date:new Date(this.state.publicSalesEndDate.date.setHours(e.value))}
      })
    } else if (type === 'EarlyAccess2Start') {
      this.updateState({
        earlyAccess2StartDate:{...this.state.earlyAccess2StartDate,hour:e,date:new Date(this.state.earlyAccess2StartDate.date.setHours(e.value))}
      })
    } else if (type === 'EarlyAccess2End') {
      this.updateState({
        earlyAccess2EndDate:{...this.state.earlyAccess2EndDate,hour:e,date:new Date(this.state.earlyAccess2EndDate.date.setHours(e.value))}
      })
    } else if (type === 'EarlyAccess3Start') {
      this.updateState({
        earlyAccess3StartDate:{...this.state.earlyAccess3StartDate,hour:e,date:new Date(this.state.earlyAccess3StartDate.date.setHours(e.value))}
      })
    } else if (type === 'EarlyAccess3End') {
      this.updateState({
        earlyAccess3EndDate:{...this.state.earlyAccess3EndDate,hour:e,date:new Date(this.state.earlyAccess3EndDate.date.setHours(e.value))}
      })
    } else if (type === 'WaitlistStart') {
      this.updateState({
        waitListStartDate:{...this.state.waitListStartDate,hour:e,date:new Date(this.state.waitListStartDate.date.setHours(e.value))}
      })
    } else {
      this.updateState({
        waitListEndDate:{...this.state.waitListEndDate,hour:e,date:new Date(this.state.waitListEndDate.date.setHours(e.value))}
      })
    }
    // this.setState({})
}

handleTimeMin = (e, type) => {
    // this.setState({})
    // this.state.dateTime.forEach(event => {
    //     if (event._id === id) {
    //         event.minutes = e
    //         event.date = new Date(event.date.setMinutes(e.value))
    //     }
    // });
    if(type === 'EarlyPriceStart'){
      this.updateState({
        earlyPriceStartDate:{...this.state.earlyPriceStartDate,min:e,date:new Date(this.state.earlyPriceStartDate.date.setMinutes(e.value))}
      })
    } else if(type === 'EarlyPriceEnd'){
      this.updateState({
        earlyPriceEndDate: { ...this.state.earlyPriceEndDate,min:e,date:new Date(this.state.earlyPriceEndDate.date.setMinutes(e.value))}
      })
    } else if(type === 'EarlyAccessStart'){
      this.updateState({
        earlyAccessStartDate:{...this.state.earlyAccessStartDate,min:e,date:new Date(this.state.earlyAccessStartDate.date.setMinutes(e.value))}
      })
    } else if(type === 'EarlyAccessEnd'){
      this.updateState({
        earlyAccessEndDate: { ...this.state.earlyAccessEndDate,min:e,date:new Date(this.state.earlyAccessEndDate.date.setMinutes(e.value))}
      })
    } else if (type === 'PublicSaleStart'){
      this.updateState({
        publicSalesStartDate:{...this.state.publicSalesStartDate,min:e,date:new Date(this.state.publicSalesStartDate.date.setMinutes(e.value))}
      })
    } else if (type === 'PublicSaleEnd') {
      this.updateState({
        publicSalesEndDate:{...this.state.publicSalesEndDate,min:e,date:new Date(this.state.publicSalesEndDate.date.setMinutes(e.value))}
      })
    } else if (type === 'EarlyAccess2Start') {
      this.updateState({
        earlyAccess2StartDate:{...this.state.earlyAccess2StartDate,min:e,date:new Date(this.state.earlyAccess2StartDate.date.setMinutes(e.value))}
      })
    } else if (type === 'EarlyAccess2End') {
      this.updateState({
        earlyAccess2EndDate:{...this.state.earlyAccess2EndDate,min:e,date:new Date(this.state.earlyAccess2EndDate.date.setMinutes(e.value))}
      })
    } else if (type === 'EarlyAccess3Start') {
      this.updateState({
        earlyAccess3StartDate:{...this.state.earlyAccess3StartDate,min:e,date:new Date(this.state.earlyAccess3StartDate.date.setMinutes(e.value))}
      })
    } else if (type === 'EarlyAccess3End') {
      this.updateState({
        earlyAccess3EndDate:{...this.state.earlyAccess3EndDate,min:e,date:new Date(this.state.earlyAccess3EndDate.date.setMinutes(e.value))}
      })
    } else if (type === 'WaitlistStart') {
      this.updateState({
        waitListStartDate:{...this.state.waitListStartDate,min:e,date:new Date(this.state.waitListStartDate.date.setMinutes(e.value))}
      })
    } else {
      this.updateState({
        waitListEndDate:{...this.state.waitListEndDate,min:e,date:new Date(this.state.waitListEndDate.date.setHours(e.value))}
      })
    }
}

handleTimeStamps = (e, type) => {
    // this.setState({})
    // this.state.dateTime.forEach(event => {
    //     if (event._id === id) {
    //         event.state = e
    //         event.date = new Date(event.date.setHours(event.hours.value, event.minutes.value, 0))
    //     }
    // });
    console.log(this.state.earlyAccessStartDate,"this.state.earlyAccessStartDate",this.state.earlyAccessStartDate.date.setHours(this.state.earlyAccessStartDate.hour.value,this.state.earlyAccessStartDate.min.value,0));
    if(type === 'EarlyPriceStart'){
      this.updateState({
        earlyPriceStartDate:{...this.state.earlyPriceStartDate,state:e,date:new Date(this.state.earlyPriceStartDate.date.setHours(this.state.earlyPriceStartDate.hour.value,this.state.earlyPriceStartDate.min.value,0))}
      })
    } else if(type === 'EarlyPriceEnd'){
      this.updateState({
        earlyPriceEndDate: { ...this.state.earlyPriceEndDate,state:e,date:new Date(this.state.earlyPriceEndDate.date.setHours(this.state.earlyPriceEndDate.hour.value,this.state.earlyPriceEndDate.min.value,0))}
      })
    } else if(type === 'EarlyAccessStart'){
      this.updateState({
        earlyAccessStartDate:{...this.state.earlyAccessStartDate,state:e,date:new Date(this.state.earlyAccessStartDate.date.setHours(this.state.earlyAccessStartDate.hour.value,this.state.earlyAccessStartDate.min.value,0))}
      })
    } else if(type === 'EarlyAccessEnd'){
      this.updateState({
        earlyAccessEndDate: { ...this.state.earlyAccessEndDate,state:e,date:new Date(this.state.earlyAccessEndDate.date.setHours(this.state.earlyAccessEndDate.hour.value,this.state.earlyAccessEndDate.min.value,0))}
      })
    } else if (type === 'PublicSaleStart'){
      this.updateState({
        publicSalesStartDate:{...this.state.publicSalesStartDate,state:e,date:new Date(this.state.publicSalesStartDate.date.setHours(this.state.publicSalesStartDate.hour.value,this.state.publicSalesStartDate.min.value,0))}
      })
    } else if (type === 'PublicSaleEnd') {
      this.updateState({
        publicSalesEndDate:{...this.state.publicSalesEndDate,state:e,date:new Date(this.state.publicSalesEndDate.date.setHours(this.state.publicSalesEndDate.hour.value,this.state.publicSalesEndDate.min.value,0))}
      })
    } else if (type === 'EarlyAccess2Start') {
      this.updateState({
        earlyAccess2StartDate:{...this.state.earlyAccess2StartDate,state:e,date:new Date(this.state.earlyAccess2StartDate.date.setHours(this.state.earlyAccess2StartDate.hour.value,this.state.earlyAccess2StartDate.min.value,0))}
      })
    } else if (type === 'EarlyAccess2End') {
      this.updateState({
        earlyAccess2EndDate:{...this.state.earlyAccess2EndDate,state:e,date:new Date(this.state.earlyAccess2EndDate.date.setHours(this.state.earlyAccess2EndDate.hour.value,this.state.earlyAccess2EndDate.min.value,0))}
      })
    } else if (type === 'EarlyAccess3Start') {
      this.updateState({
        earlyAccess3StartDate:{...this.state.earlyAccess3StartDate,state:e,date:new Date(this.state.earlyAccess3StartDate.date.setHours(this.state.earlyAccess3StartDate.hour.value,this.state.earlyAccess3StartDate.min.value,0))}
      })
    } else if (type === 'EarlyAccess3End') {
      this.updateState({
        earlyAccess3EndDate:{...this.state.earlyAccess3EndDate,state:e,date:new Date(this.state.earlyAccess3EndDate.date.setHours(this.state.earlyAccess3EndDate.hour.value,this.state.earlyAccess3EndDate.min.value,0))}
      })
    } else if (type === 'WaitlistStart') {
      this.updateState({
        waitListStartDate:{...this.state.waitListStartDate,state:e,date:new Date(this.state.waitListStartDate.date.setHours(this.state.waitListStartDate.hour.value,this.state.waitListStartDate.min.value,0))}
      })
    } else {
      this.updateState({
        waitListEndDate:{...this.state.waitListEndDate,state:e,date:new Date(this.state.waitListEndDate.date.setHours(this.state.waitListEndDate.hour.value,this.state.waitListEndDate.min.value,0))}
      })
    }
}

  onChangeScreeningType = (e) => {
    const { name, value } = e.target;
    const newValue = Number(value);
    this.setState(prevState => {
      const updatedFormData = { ...this.getCurrentFormData(), [name]: newValue };
      const isDirty = prevState.initialData ? !isEqual(prevState.initialData, updatedFormData) : prevState.isproductdetailEdited;
      return { [name]: newValue, isproductdetailEdited: isDirty };
    });
  };
  onChangeWaitlistType = (e, id) => {
    const { name, value } = e.target;
    this.updateState({
      [name]:value
    })
  };
  handleCheck = (e) => {
    const { name, value, checked } = e.target;
    this.updateState({
      [name]:checked
    })
  };
  validScreeningTypesOption = () => {
    var options = []

    this.state.validScreeningTypesOption.filter(_ => this.state.location === 'inperson' ? _.locationType === '1' : _.locationType === '2').forEach(item => {
        options.push({ value: item.type, label: item.displayName})
    });
    return options
  }
  handleChangenValidScreeningTypes = screening => {
    this.updateState({
      validScreeningTypes: screening
    })
};
  handleChangeEarlyAccess1MembershipTypes = selected => {
    this.updateState({ membershipTypes: selected || [] });
  };
  handleChangeEarlyAccess2MembershipTypes = selected => {
    this.updateState({ membership2Types: selected || [] });
  };
  handleChangeEarlyAccess3MembershipTypes = selected => {
    this.updateState({ membership3Types: selected || [] });
  };
  onChangeGroup = (e, id) => {
    const { name, value } = e.target;
    this.updateState({
      [name]:value
    });
    if(value === 'inperson' || value === 'online'){
      this.updateState({
        validScreeningTypes:[]
      })
    }
    if(name === 'group'){
      this.updateState({
        showProductInCompareBenefits: value === 'newTicketing'
      })
    }
  };
  render() {
    const { getLastUpdated } = this.state;
    var updateAt = new Date(getLastUpdated && getLastUpdated.updatedAt);
    var hour = moment(updateAt).format("h");
    var minutes = moment(updateAt).format("mm");
    var state = moment(updateAt).format("A");
    var updatedBy = getLastUpdated && getLastUpdated.updatedBy;
    const hours = [
      { value: '12', label: '12' },
      { value: '1', label: '1' },
      { value: '2', label: '2' },
      { value: '3', label: '3' },
      { value: '4', label: '4' },
      { value: '5', label: '5' },
      { value: '6', label: '6' },
      { value: '7', label: '7' },
      { value: '8', label: '8' },
      { value: '9', label: '9' },
      { value: '10', label: '10' },
      { value: '11', label: '11' },
  ]

  const minute = [
      { value: '00', label: '00' },
      { value: '05', label: '05' },
      { value: '10', label: '10' },
      { value: '15', label: '15' },
      { value: '20', label: '20' },
      { value: '25', label: '25' },
      { value: '30', label: '30' },
      { value: '35', label: '35' },
      { value: '40', label: '40' },
      { value: '45', label: '45' },
      { value: '50', label: '50' },
      { value: '55', label: '55' },
  ]

  const states = [
      { value: 'AM', label: 'AM' },
      { value: 'PM', label: 'PM' }
  ]

  const productGroup = [
    {_id:'presale',name:'PreSale'},
    {_id:'newTicketing',name:'Public'},
    {_id:'boxoffice', name:'Box Office'}
  ]
  const userGroup = [
    {_id:'industry', name:'Industry'},
    {_id:'press', name:'Press'},
    {_id:'circleGuest', name:'Sundance Guest'}
  ]
  const locationType = [
    {_id:'online', name:'Online'},
    {_id:'inperson', name:'In-Person'},
    {_id:'gala', name:'Gala'},
  ]
  const productClassificationOptions = [
    {_id:'pass', name:'Pass'},
    {_id:'ticket', name:'Ticket'}
  ]
    return (
      <React.Fragment>
        <div className="right_side_wrapper">
          <ul className="fpg_admin_tab disp_flex">
            {this.state.data &&
              this.state.data.map((list, index) => {
                return (
                  <li className="active">
                    <p className="uppercase text_left">
                      {list.label}
                      <Link to="create-film">
                        <PlusIcon />
                      </Link>
                    </p>
                  </li>
                );
              })}
          </ul>

          <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
            <Link className="back_link" to="/product-list">
              {" "}
              <svg width="5" height="10" viewBox="0 0 5 10" fill="none">
                {" "}
                <path d="M5 0L0 5L5 10V0Z" fill="black" />{" "}
              </svg>{" "}
              Back to List
              </Link>
            <p className="update_date">
              Last Update: {hour}:{minutes} {state} -{" "}
              {moment(updateAt).format("MM/DD/YYYY")} Last Updated By:{" "}
              {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname}
            </p>
          </div>
          <RecordPresenceBanner
            activeViewers={this.props.recordViewers}
            conflict={this.props.recordConflict}
          />
          <div className="product_detail_content fpg_tabcontent">
            <form>
              <div className="product_wrap_content product_content_inner">
                <div className="product_form product_coupon_form d_flex">
                  <div className="product_form_left">
                  <div className="field_row horizontal_field">
                      <TextField
                        type="text"
                        label="Eventive ID"
                        name="eventiveId"
                        value={this.state.eventiveId}
                        // disable
                        onChange={e => this.onInputChange(e)}
                        fpgerror={this.validator.message('eventiveId', this.state.eventiveId, 'required')}
                      />
                    </div>
                    <div className="field_row horizontal_field">
                      <TextField
                        type="text"
                        label="Eventive Code"
                        name="eventiveCode"
                        value={this.state.eventiveCode}
                        // disable
                        onChange={e => this.onInputChange(e)}
                        fpgerror={this.validator.message('eventiveCode', this.state.eventiveCode, 'required')}
                      />
                    </div>
                    <div className="field_row horizontal_field">
                      <TextField
                        type="text"
                        label="Product Name"
                        name="name"
                        value={this.state.name}
                        onChange={this.onInputChange}
                        fpgerror={this.validator.message('name', this.state.name, 'required')}
                      />
                    </div>
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Product Summary</label>
                        <div className="field_input relative">
                          <TextEditor
                            editorState={this.state.summary}
                            name="summary"
                            value={this.state.summary}
                            onEditorStateChange={this.onEditorStateChange}
                          />
                          {/* <textarea
                              name="summary"
                              value={this.state.summary}
                              rows="5"
                              onChange={this.onInputChange}
                            ></textarea> */}
                        </div>
                        <span className="error">{this.validator.message('summary', this.state.summary, 'required')}</span>
                      </div>
                    </div>
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Product Detail</label>
                        <div className="field_input relative">
                          <TextEditor
                            editorState={this.state.desc}
                            name="desc"
                            value={this.state.desc}
                            onEditorStateChange={this.onEditorState}
                          />
                          {/* <textarea
                              name="desc"
                              className="prod_detail"
                              rows="5"
                              value={this.state.desc}
                              onChange={this.onInputChange}
                            ></textarea> */}
                        </div>
                        <span className="error">{this.validator.message('description', this.state.desc, 'required')}</span>
                      </div>
                    </div>
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Product Giftable</label>
                        <div className="relative mt_10">
                          <div className="checkbox_field_row">
                            <div className="checkBox">
                              <input
                                type="checkbox"
                                id={`isGiftable`}
                                name={`isGiftable`}
                                checked={this.state.isGiftable}
                                onChange={(e) => this.handleCheck(e)} />
                              <label for={`isGiftable`} style={{ width: "auto" }}></label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Product Price(USD)</label>
                        <div className="field_input relative price_field">
                          <input
                            type="number"
                            name="price"
                            value={this.state.price}
                            disabled={false}
                            onChange={this.onInputChange}
                          />
                          <span className="price_symbol">$</span>
                          <span className="error">{this.validator.message('price', this.state.price, 'required')}</span>
                        </div>
                      </div>
                    </div>
                    <div className="field_row horizontal_field product_label">
                      <TextField
                        type="text"
                        label="Product Banner"
                        name="label"
                        value={this.state.label}
                        onChange={this.onInputChange}
                        fpgerror={this.state.labelError ? <span>Banner must not be greater than 25 characters long.</span> : false}
                      />
                      {}
                    </div>
                    {this.props.ProductEditListEditId !== '' && <div className="field_row horizontal_field product_access">
                      <TextField
                        type="text"
                        label="Product Group"
                        name="group"
                        value={this.state.group === 'presale' ? 'PreSale' : 'Public'}
                        // disabled={true}
                        disable
                      onChange={this.onInputChange}
                      />
                    </div>}
                    {this.props.ProductEditListEditId !== '' && <div className="field_row horizontal_field product_access">
                      <TextField
                        type="text"
                        label="Product Type"
                        name="location"
                        value={locationType.filter(_ => _._id === this.state.location)[0]?.name}
                        disable
                      />
                    </div>}
                    {this.props.ProductEditListEditId !== '' && <div className="field_row horizontal_field product_access">
                      <TextField
                        type="text"
                        label="User Group"
                        name="userGroup"
                        value={this.state.userGroup === 'industry' ? 'Industry' : this.state.userGroup === "press" ? 'Press' : this.state.userGroup === 'circleGuest' ? 'Circle Guest' : this.state.userGroup === 'general' ? 'General' : 'Box Office'}
                        disable
                      />
                    </div>}
                    {this.props.ProductEditListEditId !== '' && <div className="field_row horizontal_field product_access">
                      <TextField
                        type="text"
                        label="Product Classification"
                        name="productClassification"
                        value={this.state.productClassification === 'ticket' ? 'Ticket' : 'Pass'}
                        disable
                      />
                    </div>}
                    {!this.props.ProductEditListEditId &&
                      <>
                        <div className="field_row horizontal_field">
                          <div className="field_row_inner">
                            <label>Product Type</label>
                            <div className="form_group_countdown d_flex d_flex_align_center">
                              <DropdownMaster
                                name="location"
                                onChange={(e) => this.onChangeGroup(e,)}
                                value={this.state.location}
                                options={locationType}
                                fpgerror={this.validator.message('product type', this.state.location, 'required')}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="field_row horizontal_field">
                          <div className="field_row_inner">
                            <label>Product Classification</label>
                            <div className="form_group_countdown d_flex d_flex_align_center">
                              <DropdownMaster
                                name="productClassification"
                                onChange={(e) => this.onChangeGroup(e)}
                                value={this.state.productClassification}
                                options={productClassificationOptions}
                                fpgerror={this.validator.message('product classification', this.state.productClassification, 'required')}
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    }
                    {!this.props.ProductEditListEditId && 
                      <>
                        <div className="field_row horizontal_field">
                          <div className="field_row_inner">
                            <label>Product Group</label>
                            <div className="form_group_countdown d_flex d_flex_align_center">
                              <DropdownMaster
                                name="group"
                                onChange={(e) => this.onChangeGroup(e,)}
                                value={this.state.group}
                                options={productGroup}
                                fpgerror={this.validator.message('group', this.state.group, 'required')}
                              />
                            </div>
                          </div>
                        </div>
                        {this.state.group === 'presale' &&
                          <div className="field_row horizontal_field">
                            <div className="field_row_inner">
                              <label>User Group</label>
                              <div className="form_group_countdown d_flex d_flex_align_center">
                                <DropdownMaster
                                  name="userGroup"
                                  onChange={(e) => this.onChangeGroup(e,)}
                                  value={this.state.userGroup}
                                  options={userGroup}
                                  fpgerror={this.validator.message('user group', this.state.userGroup, 'required')}
                                />
                              </div>
                            </div>
                          </div>
                        }
                      </>
                    }
                    <div className="field_row horizontal_field">
                      <DropdownMaster
                        label="Sponsor Name"
                        name="sponsorName"
                        options={(this.state.eventSponsors || []).map(s => ({ _id: s.name, name: s.name }))}
                        value={this.state.sponsorName}
                        onChange={(e) => this.updateState({ sponsorName: e.target.value })}
                      />
                    </div>
                  </div>
                  <div className="product_form_right">
                    {this.state.group === 'presale' && this.state.userGroup === 'industry' && <div className="product_mylib">
                      <h3>Early Bird Access</h3>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Product Early Price(USD)</label>
                          <div className="field_input relative price_field">
                            <input
                              type="number"
                              name="earlyPrice"
                              value={this.state.earlyPrice}
                              disabled={false}
                              onChange={this.onInputChange}
                            />
                            <span className="price_symbol">$</span>
                          </div>
                        </div>
                      </div>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Product Early Text </label>
                          <div className="field_input relative">
                            <input
                              type="text"
                              name="earlyPriceText"
                              value={this.state.earlyPriceText}
                              disabled={false}
                              onChange={this.onInputChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Early Price Start Date & Time (MT)</label>
                          <div className="form_group_countdown d_flex d_flex_align_center">
                            <TextField type="text" name="countDownDate"
                                // disable={true}
                                value={moment(this.state.earlyPriceStartDate?.date).format(
                                    "MM/DD/YYYY"
                                )}
                                placeholder="mm / dd / yyyy"
                            />
                            <span className="calendar_img">
                                <DatePicker
                                    // disabled={true}
                                    selected={this.state.earlyPriceStartDate?.date}
                                    onChange={(e) => this.handleChangeDate(e, 'EarlyPriceStart')}
                                    minDate={moment().toDate()}
                                    placeholder="mm/dd/yyyy"
                                    customInput={
                                        <span className="calendar">
                                            <CalendarIcon />
                                        </span>
                                    }
                                />
                            </span>
                            <Select
                                options={hours}
                                value={this.state.earlyPriceStartDate?.hour}
                                name='hours'
                                placeholder="9"
                                onChange={(e) => this.handleTimeHours(e,'EarlyPriceStart')} />
                            <Select
                                options={minute}
                                value={this.state.earlyPriceStartDate?.min}
                                name='minutes'
                                placeholder="00"
                                onChange={(e) => this.handleTimeMin(e,'EarlyPriceStart')} />
                            <Select
                                options={states}
                                value={this.state.earlyPriceStartDate?.state}
                                name='state'
                                placeholder="AM"
                                onChange={(e) => this.handleTimeStamps(e,'EarlyPriceStart')} />
                          </div>
                        </div>
                      </div>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Early Price End Date & Time (MT)</label>
                          <div className="form_group_countdown d_flex d_flex_align_center">
                            <TextField type="text" name="countDownDate"
                                // disable={true}
                                value={moment(this.state.earlyPriceEndDate?.date).format(
                                    "MM/DD/YYYY"
                                )}
                                placeholder="mm / dd / yyyy"
                            />
                            <span className="calendar_img">
                                <DatePicker
                                    // disabled={true}
                                    selected={this.state.earlyPriceEndDate?.date}
                                    onChange={(e) => this.handleChangeDate(e, 'EarlyPriceEnd')}
                                    minDate={moment().toDate()}
                                    placeholder="mm/dd/yyyy"
                                    customInput={
                                        <span className="calendar">
                                            <CalendarIcon />
                                        </span>
                                    }
                                />
                            </span>
                            <Select
                                options={hours}
                                value={this.state.earlyPriceEndDate?.hour}
                                name='hours'
                                placeholder="9"
                                onChange={(e) => this.handleTimeHours(e,'EarlyPriceEnd')} />
                            <Select
                                options={minute}
                                value={this.state.earlyPriceEndDate?.min}
                                name='minutes'
                                placeholder="00"
                                onChange={(e) => this.handleTimeMin(e,'EarlyPriceEnd')} />
                            <Select
                                options={states}
                                value={this.state.earlyPriceEndDate?.state}
                                name='state'
                                placeholder="AM"
                                onChange={(e) => this.handleTimeStamps(e,'EarlyPriceEnd')} />
                          </div>
                        </div>
                      </div>
                    </div>}
                    {(this.state.group === 'presale' && (this.state.userGroup === 'press' || this.state.userGroup === 'industry')) && <>
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Early Access Start Date & Time (MT)</label>
                        <div className="form_group_countdown d_flex d_flex_align_center">
                          <TextField type="text" name="countDownDate"
                              // disable={true}
                              value={moment(this.state.earlyAccessStartDate.date).format(
                                  "MM/DD/YYYY"
                              )}
                              placeholder="mm / dd / yyyy"
                          />
                          {console.log('earlyAccessStartDate',this.state.earlyAccessStartDate)}
                          <span className="calendar_img">
                              <DatePicker
                                  // disabled={true}
                                  selected={this.state.earlyAccessStartDate.date}
                                  onChange={(e) => this.handleChangeDate(e, 'EarlyAccessStart')}
                                  minDate={moment().toDate()}
                                  placeholder="mm/dd/yyyy"
                                  customInput={
                                      <span className="calendar">
                                          <CalendarIcon />
                                      </span>
                                  }
                              />
                          </span>
                          <Select
                              options={hours}
                              value={this.state.earlyAccessStartDate.hour}
                              name='hours'
                              placeholder="9"
                              onChange={(e) => this.handleTimeHours(e,'EarlyAccessStart')} />
                          <Select
                              options={minute}
                              value={this.state.earlyAccessStartDate.min}
                              name='minutes'
                              placeholder="00"
                              onChange={(e) => this.handleTimeMin(e,'EarlyAccessStart')} />
                          <Select
                              options={states}
                              value={this.state.earlyAccessStartDate.state}
                              name='state'
                              placeholder="AM"
                              onChange={(e) => this.handleTimeStamps(e,'EarlyAccessStart')} />
                        </div>
                      </div>
                    </div>
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Early Access End Date & Time (MT)</label>
                        <div className="form_group_countdown d_flex d_flex_align_center">
                          <TextField type="text" name="countDownDate"
                              // disable={true}
                              value={moment(this.state.earlyAccessEndDate.date).format(
                                  "MM/DD/YYYY"
                              )}
                              placeholder="mm / dd / yyyy"
                          />
                          <span className="calendar_img">
                              <DatePicker
                                  // disabled={true}
                                  selected={this.state.earlyAccessEndDate.date}
                                  onChange={(e) => this.handleChangeDate(e, 'EarlyAccessEnd')}
                                  minDate={moment().toDate()}
                                  placeholder="mm/dd/yyyy"
                                  customInput={
                                      <span className="calendar">
                                          <CalendarIcon />
                                      </span>
                                  }
                              />
                          </span>
                          <Select
                              options={hours}
                              value={this.state.earlyAccessEndDate.hour}
                              name='hours'
                              placeholder="9"
                              onChange={(e) => this.handleTimeHours(e,'EarlyAccessEnd')} />
                          <Select
                              options={minute}
                              value={this.state.earlyAccessEndDate.min}
                              name='minutes'
                              placeholder="00"
                              onChange={(e) => this.handleTimeMin(e,'EarlyAccessEnd')} />
                          <Select
                              options={states}
                              value={this.state.earlyAccessEndDate.state}
                              name='state'
                              placeholder="AM"
                              onChange={(e) => this.handleTimeStamps(e,'EarlyAccessEnd')} />
                        </div>
                      </div>
                    </div>
                    </>}
                    {(this.state.group === 'newTicketing' || (this.state.group === 'presale' && this.state.userGroup === 'circleGuest')) && <>
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Early Access 1 Start Date & Time (MT)</label>
                        <div className="form_group_countdown d_flex d_flex_align_center">
                          <TextField type="text" name="countDownDate"
                              // disable={true}
                              value={moment(this.state.earlyAccessStartDate.date).format(
                                  "MM/DD/YYYY"
                              )}
                              placeholder="mm / dd / yyyy"
                          />
                          {console.log('earlyAccessStartDate',this.state.earlyAccessStartDate)}
                          <span className="calendar_img">
                              <DatePicker
                                  // disabled={true}
                                  selected={this.state.earlyAccessStartDate.date}
                                  onChange={(e) => this.handleChangeDate(e, 'EarlyAccessStart')}
                                  minDate={moment().toDate()}
                                  placeholder="mm/dd/yyyy"
                                  customInput={
                                      <span className="calendar">
                                          <CalendarIcon />
                                      </span>
                                  }
                              />
                          </span>
                          <Select
                              options={hours}
                              value={this.state.earlyAccessStartDate.hour}
                              name='hours'
                              placeholder="9"
                              onChange={(e) => this.handleTimeHours(e,'EarlyAccessStart')} />
                          <Select
                              options={minute}
                              value={this.state.earlyAccessStartDate.min}
                              name='minutes'
                              placeholder="00"
                              onChange={(e) => this.handleTimeMin(e,'EarlyAccessStart')} />
                          <Select
                              options={states}
                              value={this.state.earlyAccessStartDate.state}
                              name='state'
                              placeholder="AM"
                              onChange={(e) => this.handleTimeStamps(e,'EarlyAccessStart')} />
                        </div>
                      </div>
                    </div>
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Early Access 1 End Date & Time (MT)</label>
                        <div className="form_group_countdown d_flex d_flex_align_center">
                          <TextField type="text" name="countDownDate"
                              // disable={true}
                              value={moment(this.state.earlyAccessEndDate.date).format(
                                  "MM/DD/YYYY"
                              )}
                              placeholder="mm / dd / yyyy"
                          />
                          <span className="calendar_img">
                              <DatePicker
                                  // disabled={true}
                                  selected={this.state.earlyAccessEndDate.date}
                                  onChange={(e) => this.handleChangeDate(e, 'EarlyAccessEnd')}
                                  minDate={moment().toDate()}
                                  placeholder="mm/dd/yyyy"
                                  customInput={
                                      <span className="calendar">
                                          <CalendarIcon />
                                      </span>
                                  }
                              />
                          </span>
                          <Select
                              options={hours}
                              value={this.state.earlyAccessEndDate.hour}
                              name='hours'
                              placeholder="9"
                              onChange={(e) => this.handleTimeHours(e,'EarlyAccessEnd')} />
                          <Select
                              options={minute}
                              value={this.state.earlyAccessEndDate.min}
                              name='minutes'
                              placeholder="00"
                              onChange={(e) => this.handleTimeMin(e,'EarlyAccessEnd')} />
                          <Select
                              options={states}
                              value={this.state.earlyAccessEndDate.state}
                              name='state'
                              placeholder="AM"
                              onChange={(e) => this.handleTimeStamps(e,'EarlyAccessEnd')} />
                        </div>
                      </div>
                    </div>
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Membership Type</label>
                        <div className="select_field relative">
                          <Select
                            isMulti
                            options={this.state.membershipLevelsOptions.filter(opt => !this.state.membership2Types.some(m => m.value === opt.value) && !this.state.membership3Types.some(m => m.value === opt.value))}
                            value={this.state.membershipTypes}
                            onChange={this.handleChangeEarlyAccess1MembershipTypes}
                            placeholder="Select membership types..."
                            closeMenuOnSelect={false}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Early Access 2 Start Date & Time (MT)</label>
                        <div className="form_group_countdown d_flex d_flex_align_center">
                          <TextField type="text" name="countDownDate"
                              value={moment(this.state.earlyAccess2StartDate.date).format("MM/DD/YYYY")}
                              placeholder="mm / dd / yyyy"
                          />
                          <span className="calendar_img">
                              <DatePicker
                                  selected={this.state.earlyAccess2StartDate.date}
                                  onChange={(e) => this.handleChangeDate(e, 'EarlyAccess2Start')}
                                  minDate={moment().toDate()}
                                  placeholder="mm/dd/yyyy"
                                  customInput={<span className="calendar"><CalendarIcon /></span>}
                              />
                          </span>
                          <Select
                              options={hours}
                              value={this.state.earlyAccess2StartDate.hour}
                              name='hours'
                              placeholder="9"
                              onChange={(e) => this.handleTimeHours(e,'EarlyAccess2Start')} />
                          <Select
                              options={minute}
                              value={this.state.earlyAccess2StartDate.min}
                              name='minutes'
                              placeholder="00"
                              onChange={(e) => this.handleTimeMin(e,'EarlyAccess2Start')} />
                          <Select
                              options={states}
                              value={this.state.earlyAccess2StartDate.state}
                              name='state'
                              placeholder="AM"
                              onChange={(e) => this.handleTimeStamps(e,'EarlyAccess2Start')} />
                        </div>
                      </div>
                    </div>
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Early Access 2 End Date & Time (MT)</label>
                        <div className="form_group_countdown d_flex d_flex_align_center">
                          <TextField type="text" name="countDownDate"
                              value={moment(this.state.earlyAccess2EndDate.date).format("MM/DD/YYYY")}
                              placeholder="mm / dd / yyyy"
                          />
                          <span className="calendar_img">
                              <DatePicker
                                  selected={this.state.earlyAccess2EndDate.date}
                                  onChange={(e) => this.handleChangeDate(e, 'EarlyAccess2End')}
                                  minDate={moment().toDate()}
                                  placeholder="mm/dd/yyyy"
                                  customInput={<span className="calendar"><CalendarIcon /></span>}
                              />
                          </span>
                          <Select
                              options={hours}
                              value={this.state.earlyAccess2EndDate.hour}
                              name='hours'
                              placeholder="9"
                              onChange={(e) => this.handleTimeHours(e,'EarlyAccess2End')} />
                          <Select
                              options={minute}
                              value={this.state.earlyAccess2EndDate.min}
                              name='minutes'
                              placeholder="00"
                              onChange={(e) => this.handleTimeMin(e,'EarlyAccess2End')} />
                          <Select
                              options={states}
                              value={this.state.earlyAccess2EndDate.state}
                              name='state'
                              placeholder="AM"
                              onChange={(e) => this.handleTimeStamps(e,'EarlyAccess2End')} />
                        </div>
                      </div>
                    </div>
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Membership Type</label>
                        <div className="select_field relative">
                          <Select
                            isMulti
                            options={this.state.membershipLevelsOptions.filter(opt => !this.state.membershipTypes.some(m => m.value === opt.value) && !this.state.membership3Types.some(m => m.value === opt.value))}
                            value={this.state.membership2Types}
                            onChange={this.handleChangeEarlyAccess2MembershipTypes}
                            placeholder="Select membership types..."
                            closeMenuOnSelect={false}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Early Access 3 Start Date & Time (MT)</label>
                        <div className="form_group_countdown d_flex d_flex_align_center">
                          <TextField type="text" name="countDownDate"
                              value={moment(this.state.earlyAccess3StartDate.date).format("MM/DD/YYYY")}
                              placeholder="mm / dd / yyyy"
                          />
                          <span className="calendar_img">
                              <DatePicker
                                  selected={this.state.earlyAccess3StartDate.date}
                                  onChange={(e) => this.handleChangeDate(e, 'EarlyAccess3Start')}
                                  minDate={moment().toDate()}
                                  placeholder="mm/dd/yyyy"
                                  customInput={<span className="calendar"><CalendarIcon /></span>}
                              />
                          </span>
                          <Select
                              options={hours}
                              value={this.state.earlyAccess3StartDate.hour}
                              name='hours'
                              placeholder="9"
                              onChange={(e) => this.handleTimeHours(e,'EarlyAccess3Start')} />
                          <Select
                              options={minute}
                              value={this.state.earlyAccess3StartDate.min}
                              name='minutes'
                              placeholder="00"
                              onChange={(e) => this.handleTimeMin(e,'EarlyAccess3Start')} />
                          <Select
                              options={states}
                              value={this.state.earlyAccess3StartDate.state}
                              name='state'
                              placeholder="AM"
                              onChange={(e) => this.handleTimeStamps(e,'EarlyAccess3Start')} />
                        </div>
                      </div>
                    </div>
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Early Access 3 End Date & Time (MT)</label>
                        <div className="form_group_countdown d_flex d_flex_align_center">
                          <TextField type="text" name="countDownDate"
                              value={moment(this.state.earlyAccess3EndDate.date).format("MM/DD/YYYY")}
                              placeholder="mm / dd / yyyy"
                          />
                          <span className="calendar_img">
                              <DatePicker
                                  selected={this.state.earlyAccess3EndDate.date}
                                  onChange={(e) => this.handleChangeDate(e, 'EarlyAccess3End')}
                                  minDate={moment().toDate()}
                                  placeholder="mm/dd/yyyy"
                                  customInput={<span className="calendar"><CalendarIcon /></span>}
                              />
                          </span>
                          <Select
                              options={hours}
                              value={this.state.earlyAccess3EndDate.hour}
                              name='hours'
                              placeholder="9"
                              onChange={(e) => this.handleTimeHours(e,'EarlyAccess3End')} />
                          <Select
                              options={minute}
                              value={this.state.earlyAccess3EndDate.min}
                              name='minutes'
                              placeholder="00"
                              onChange={(e) => this.handleTimeMin(e,'EarlyAccess3End')} />
                          <Select
                              options={states}
                              value={this.state.earlyAccess3EndDate.state}
                              name='state'
                              placeholder="AM"
                              onChange={(e) => this.handleTimeStamps(e,'EarlyAccess3End')} />
                        </div>
                      </div>
                    </div>
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Membership Type</label>
                        <div className="select_field relative">
                          <Select
                            isMulti
                            options={this.state.membershipLevelsOptions.filter(opt => !this.state.membershipTypes.some(m => m.value === opt.value) && !this.state.membership2Types.some(m => m.value === opt.value))}
                            value={this.state.membership3Types}
                            onChange={this.handleChangeEarlyAccess3MembershipTypes}
                            placeholder="Select membership types..."
                            closeMenuOnSelect={false}
                          />
                        </div>
                      </div>
                    </div>
                    </>}
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Public Sales Start Date & Time (MT)</label>
                        <div className="form_group_countdown d_flex d_flex_align_center">
                          <TextField type="text" name="countDownDate"
                              // disable={true}
                              value={moment(this.state.publicSalesStartDate.date).format(
                                  "MM/DD/YYYY"
                              )}
                              placeholder="mm / dd / yyyy"
                          />
                          <span className="calendar_img">
                              <DatePicker
                                  // disabled={true}
                                  selected={this.state.publicSalesStartDate.date}
                                  onChange={(e) => this.handleChangeDate(e, 'PublicSaleStart')}
                                  minDate={moment().toDate()}
                                  placeholder="mm/dd/yyyy"
                                  customInput={
                                      <span className="calendar">
                                          <CalendarIcon />
                                      </span>
                                  }
                              />
                          </span>
                          <Select
                              options={hours}
                              value={this.state.publicSalesStartDate.hour}
                              name='hours'
                              placeholder="9"
                              onChange={(e) => this.handleTimeHours(e,'PublicSaleStart')} />
                          <Select
                              options={minute}
                              value={this.state.publicSalesStartDate.min}
                              name='minutes'
                              placeholder="00"
                              onChange={(e) => this.handleTimeMin(e,'PublicSaleStart')} />
                          <Select
                              options={states}
                              value={this.state.publicSalesStartDate.state}
                              name='state'
                              placeholder="AM"
                              onChange={(e) => this.handleTimeStamps(e,'PublicSaleStart')} />
                        </div>
                      </div>
                    </div>
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Public Sales End Date & Time (MT)</label>
                        <div className="form_group_countdown d_flex d_flex_align_center">
                          <TextField type="text" name="countDownDate"
                              // disable={true}
                              value={moment(this.state.publicSalesEndDate.date).format(
                                  "MM/DD/YYYY"
                              )}
                              placeholder="mm / dd / yyyy"
                          />
                          <span className="calendar_img">
                              <DatePicker
                                  // disabled={true}
                                  selected={this.state.publicSalesEndDate.date}
                                  onChange={(e) => this.handleChangeDate(e, 'PublicSaleEnd')}
                                  minDate={moment().toDate()}
                                  placeholder="mm/dd/yyyy"
                                  customInput={
                                      <span className="calendar">
                                          <CalendarIcon />
                                      </span>
                                  }
                              />
                          </span>
                          <Select
                              options={hours}
                              value={this.state.publicSalesEndDate.hour}
                              name='hours'
                              placeholder="9"
                              onChange={(e) => this.handleTimeHours(e,'PublicSaleEnd')} />
                          <Select
                              options={minute}
                              value={this.state.publicSalesEndDate.min}
                              name='minutes'
                              placeholder="00"
                              onChange={(e) => this.handleTimeMin(e,'PublicSaleEnd')} />
                          <Select
                              options={states}
                              value={this.state.publicSalesEndDate.state}
                              name='state'
                              placeholder="AM"
                              onChange={(e) => this.handleTimeStamps(e,'PublicSaleEnd')} />
                        </div>
                      </div>
                    </div>
                    <div className="product_mylib">
                      <h3>My Viewing Room</h3>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>My Viewing Room Type </label>
                          <div className="form_group_countdown d_flex d_flex_align_center">
                            <DropdownMaster
                              name="myLibraryType"
                              onChange={(e) => this.onChangeScreeningType(e,)}
                              value={this.state.myLibraryType}
                              options={this.state.screeningType}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="product_mylib">
                      <h3>Waitlist</h3>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Waitlist Type </label>
                          <div className="form_group_countdown d_flex d_flex_align_center">
                            <DropdownMaster
                              name="waitlistType"
                              onChange={(e) => this.onChangeWaitlistType(e,)}
                              value={this.state.waitlistType}
                              options={this.state.waitlistTypeOption}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Bypass Sold Out</label>
                          <div className="relative mt_10">
                              <div className="checkbox_field_row">
                                  <div className="checkBox">
                                      <input
                                          type="checkbox"
                                          id={`isByPass`}
                                          name={`isByPass`}
                                          checked={this.state.isByPass}
                                          onChange={(e) => this.handleCheck(e)} />
                                      <label for={`isByPass`} style={{ width: "auto" }}></label>
                                  </div>
                              </div>
                          </div>
                        </div>
                      </div>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Allowed Screenings Types</label>
                          <div className="select_field relative">
                              <Select
                                  isMulti
                                  onChange={this.handleChangenValidScreeningTypes}
                                  options={this.validScreeningTypesOption()}
                                 value={this.state && this.state.validScreeningTypes}
                              />
                          </div>
                        </div>
                      </div>
                      <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Waitlist Start Date & Time (MT)</label>
                        <div className="form_group_countdown d_flex d_flex_align_center">
                          <TextField type="text" name="countDownDate"
                              // disable={true}
                              value={moment(this.state.waitListStartDate.date).format(
                                  "MM/DD/YYYY"
                              )}
                              placeholder="mm / dd / yyyy"
                          />
                          <span className="calendar_img">
                              <DatePicker
                                  // disabled={true}
                                  selected={this.state.waitListStartDate.date}
                                  onChange={(e) => this.handleChangeDate(e, 'WaitlistStart')}
                                  minDate={moment().toDate()}
                                  placeholder="mm/dd/yyyy"
                                  customInput={
                                      <span className="calendar">
                                          <CalendarIcon />
                                      </span>
                                  }
                              />
                          </span>
                          <Select
                              options={hours}
                              value={this.state.waitListStartDate.hour}
                              name='hours'
                              placeholder="9"
                              onChange={(e) => this.handleTimeHours(e,'WaitlistStart')} />
                          <Select
                              options={minute}
                              value={this.state.waitListStartDate.min}
                              name='minutes'
                              placeholder="00"
                              onChange={(e) => this.handleTimeMin(e,'WaitlistStart')} />
                          <Select
                              options={states}
                              value={this.state.waitListStartDate.state}
                              name='state'
                              placeholder="AM"
                              onChange={(e) => this.handleTimeStamps(e,'WaitlistStart')} />
                        </div>
                      </div>
                    </div>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Waitlist End Date & Time (MT)</label>
                          <div className="form_group_countdown d_flex d_flex_align_center">
                            <TextField type="text" name="countDownDate"
                                // disable={true}
                                value={moment(this.state.waitListEndDate.date).format(
                                    "MM/DD/YYYY"
                                )}
                                placeholder="mm / dd / yyyy"
                            />
                            <span className="calendar_img">
                                <DatePicker
                                    // disabled={true}
                                    selected={this.state.waitListEndDate.date}
                                    onChange={(e) => this.handleChangeDate(e, 'WaitlistEnd')}
                                    minDate={moment().toDate()}
                                    placeholder="mm/dd/yyyy"
                                    customInput={
                                        <span className="calendar">
                                            <CalendarIcon />
                                        </span>
                                    }
                                />
                            </span>
                            <Select
                                options={hours}
                                value={this.state.waitListEndDate.hour}
                                name='hours'
                                placeholder="9"
                                onChange={(e) => this.handleTimeHours(e,'WaitlistEnd')} />
                            <Select
                                options={minute}
                                value={this.state.waitListEndDate.min}
                                name='minutes'
                                placeholder="00"
                                onChange={(e) => this.handleTimeMin(e,'WaitlistEnd')} />
                            <Select
                                options={states}
                                value={this.state.waitListEndDate.state}
                                name='state'
                                placeholder="AM"
                                onChange={(e) => this.handleTimeStamps(e,'WaitlistEnd')} />
                          </div>
                        </div>
                      </div>
                    </div>
                    {this.state.group === 'newTicketing' && <ProductCompareBenefits
                      productType={this.state.location}
                      value={this.state.productBenefits}
                      onChange={(productBenefits) => this.updateState({ productBenefits })}
                      showProductInCompareBenefits={this.state.showProductInCompareBenefits}
                      onShowProductInCompareBenefitsChange={(showProductInCompareBenefits) => this.updateState({ showProductInCompareBenefits })}
                    />}
                  </div>
                </div>
                {this.props.ProductEditListEditId !== '' && <div className="product_actions">
                  <div className="fpg_edits_links d_flex d_flex_align_center">
                    {/* <Link className="d_flex d_flex_align_center d_flex_justify_center"><FpgeeditIcon />EDIT</Link> */}
                    {(this.state.group === 'presale' && this.state.onSoldOut) && (this.state.adminStatus === 2 ?
                      <Link
                        className="d_flex d_flex_align_center d_flex_justify_center"
                        onClick={(e) => this.adminStatusUpdate(e,this.state.adminStatus)}
                      >
                        <FpgAdminOnlyicon /> Admin only
                      </Link>
                      :
                      <Link
                        className="d_flex d_flex_align_center d_flex_justify_center"
                        onClick={(e) => this.adminStatusUpdate(e,this.state.adminStatus)}
                      >
                       <FpgpublishIcon /> Standard
                    </Link>
                    )}
                    {this.state.onSoldOut ?
                      <Link
                        className="d_flex d_flex_align_center d_flex_justify_center"
                        onClick={() => this.soldOutFilm()}
                      >
                        <FpgpublishIcon /> ON SALE
                  </Link>
                      :
                      <Link
                        className="d_flex d_flex_align_center d_flex_justify_center"
                        onClick={() => this.soldOutFilm()}
                      >
                        <FpgDisableIcon /> Mark as Sold Out
                    </Link>

                    }
                    {this.state.status === 1 ?
                      this.state.onSoldOut &&
                      <Link
                        className="d_flex d_flex_align_center d_flex_justify_center"
                        onClick={() => this.disableFilm()}
                      >
                        <FpgDisableIcon /> DISABLE
                    </Link>
                      :
                      <Link
                        className="d_flex d_flex_align_center d_flex_justify_center"
                        onClick={() => this.publishFilm()}
                      >
                        <FpgpublishIcon /> PUBLISH
                  </Link>
                    }
                    {this.state.hideFromLive === true ?
                      <Link className="d_flex d_flex_align_center d_flex_justify_center sd_show_hide_btn" onClick={() => this.hideFromLiveFilm()}>
                        <ViewIcon /> Show On Live
                        </Link>
                      :
                      <Link className="d_flex d_flex_align_center d_flex_justify_center sd_show_hide_btn" onClick={() => this.showFromLiveFilm()}>
                        <ShowPassIcon /> Hide From Live
                        </Link>
                    }
                    {/* <Link
                      className="d_flex d_flex_align_center d_flex_justify_center"
                      onClick={() => this.deleteFilm()}
                    >
                      <FpgDeleteIcon />
                      DELETE
                      </Link> */}
                  </div>
                </div>}
              </div>
              <div className="text_center field_row w_100 buttons_outer">
                <button className="uppercase" onClick={e => this.cancel(e)} type="button">CANCEL</button>
                <button
                  className={`${this.state.loaderFlag || (this.props.ProductEditListEditId ? !this.state.isproductdetailEdited : false) ? '' : "active"}`}
                  onClick={(e) => this.submitFn(e)}
                  disabled={this.state.loaderFlag || (this.props.ProductEditListEditId ? !this.state.isproductdetailEdited : false)}
                >
                  SAVE
                  </button>
              </div>
            </form>
          </div>
        </div>
        { this.state.productAdminStatus && (this.state.adminStatus === 1 ? (
            <PopUpCustomAll
              HeaderName="Standard?"
              insideDetails="You are about to change this product status to Standard."
              insideData="Do you want to proceed?"
              popupState={this.closeAdminUser}
              yesPopUp={this.adminStatusYes}
            />
          ) : (
              <PopUpCustomAll
                HeaderName="Admin Only?"
                insideDetails="You are about to change this product status to Admin Only."
                insideData="Do you want to proceed?"
                popupState={this.closeAdminUser}
                yesPopUp={this.adminStatusYes}
              />
          ))}
        {this.state.onSale ? (
          this.state.onSoldOut ? (
            <PopUpCustomAll
              HeaderName="On Sale?"
              insideDetails="You are about to put the product On Sale. This will make it available to purchase on the site."
              insideData="Do you want to proceed?"
              popupState={this.closeAdminUser}
              yesPopUp={this.soldOutYes}
            />
          ) : (
              <PopUpCustomAll
                HeaderName="Mark as Sold Out?"
                insideDetails="You are about to mark the product as Sold Out. This will prevent anyone from purchasing it."
                insideData="Do you want to proceed?"
                popupState={this.closeAdminUser}
                yesPopUp={this.soldOutYes}
              />
            )
        ) : (
            // <PopUpCustomAll
            //   HeaderName="Mark as Sold Out?"
            //   insideDetails="You are about to mark the product as Sold Out. This will prevent anyone from purchasing it."
            //   insideData="Do you want to proceed?"
            //   popupState={this.closeAdminUser}
            //   yesPopUp={this.soldOutYes}
            // />
            ''
          )}
        {this.state.deleteFilm ? (
          <PopUpCustomAll
            HeaderName="Delete?"
            insideDetails="You are about to delete an item and this action is permanent"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.deleteFilmPopupYes}
          />
        ) : (
            ""
          )}
        {this.state.publishFilm ? (
          <PopUpCustomAll
            HeaderName="Publish Changes"
            insideDetails="Saving the current changes will publish it to the production site"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.publishFilmPopupYes}
          />
        ) : (
            ""
          )}
        {this.state.disableFilm ? (
          <PopUpCustomAll
            HeaderName="Disable?"
            insideDetails="You are about to disable an item, which will temporarily make it unavailable on the production site"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.disableFilmPopupYes}
          />
        ) : (
            ""
          )}
        {this.state.discardPopup ? (
          <PopUpCustomAll
            HeaderName="Discard Changes?"
            insideDetails="Leaving this page without saving will discard all changes"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.discardPopupYes}
          />
        ) : (
            ""
          )}
        {
          this.state.showFromLiveFilm ?
            <PopUpCustomAll
              HeaderName='Hide From Live'
              insideDetails='Saving the current changes will hide it from the site'
              insideData='Do you want to proceed?'
              popupState={this.closeAdminUser}
              yesPopUp={this.hideFromLiveFilmPopupYes}
            />
            : ''
        }
        {
          this.state.hideFromLiveFilm ?
            <PopUpCustomAll
              HeaderName='Show On Live?'
              insideDetails='Saving the current changes will show it to the site'
              insideData='Do you want to proceed?'
              popupState={this.closeAdminUser}
              yesPopUp={this.showFromLiveFilmPopupYes}
            />
            : ''
        }
        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button
                  className="small_btn active"
                  onClick={this.validateModel}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
        <ConflictSaveModal
          isVisible={this.state.showConflictModal}
          conflict={this.props.recordConflict}
          onClose={() => this.setState({ showConflictModal: false })}
        />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetail);
